import script from "./MoleculeTable.vue?vue&type=script&setup=true&lang=js"
export * from "./MoleculeTable.vue?vue&type=script&setup=true&lang=js"

import "./MoleculeTable.vue?vue&type=style&index=0&id=a5101890&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5101890"]])

export default __exports__